import { Base } from './_base.model';

export class ContactNote extends Base {
  id: number;
  contact_id: string;
  user_id: string;
  comment: string;
  created_at: string;
}
